import { render, staticRenderFns } from "./EditMarque.vue?vue&type=template&id=504531ec&"
import script from "./EditMarque.vue?vue&type=script&lang=js&"
export * from "./EditMarque.vue?vue&type=script&lang=js&"
import style0 from "./EditMarque.vue?vue&type=style&index=0&id=504531ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports